import { render, staticRenderFns } from "./JsonChildListSetterDialog.vue?vue&type=template&id=1f19d65b&"
import script from "./JsonChildListSetterDialog.vue?vue&type=script&lang=js&"
export * from "./JsonChildListSetterDialog.vue?vue&type=script&lang=js&"
import style0 from "./JsonChildListSetterDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports